import MultiSelectFilter from "components/Search/MultiSelectFilter/MultiSelectFilter";
import { connect } from "react-redux";
import { saveClientSideFilters } from "actions/filters";

const mapStateToProps = (state) => {
    return {
        clientSideFilters: state.filters.clientSideFilters,
    };
};

const mapDispatchToProps = (dispatch) => ({
    saveClientSideFilters(filters) {
        dispatch(saveClientSideFilters(filters));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelectFilter);